export enum Color {
  Blue_100 = 'Blue_100', // Ultramarine blue_20
  Blue_200 = 'Blue_200', // Ultramarine blue_40
  Blue_300 = 'Blue_300', // Ultramarine blue_60
  Blue_400 = 'Blue_400', // Ultramarine blue_80
  Blue_500_Ultramarine = 'Blue_500_Ultramarine', // Ultramarine blue
  Blue_600 = 'Blue_600', // Deep blue_20
  Blue_700 = 'Blue_700', // Deep blue_40
  Blue_800 = 'Blue_800', // Deep blue_60
  Blue_900 = 'Blue_900', // Deep blue_80
  Blue_1000_Deep = 'Blue_1000_Deep', // Deep blue

  Green_100 = 'Green_100',
  Green_200 = 'Green_200',
  Green_300 = 'Green_300',
  Green_400 = 'Green_400',
  Green_500_Success = 'Green_500_Success',
  Green_600 = 'Green_600',
  Green_700_Shop = 'Green_700_Shop',
  Green_800 = 'Green_800',
  Green_900 = 'Green_900',
  Green_1000_Energy = 'Green_1000_Energy',

  Neutral_0_White = 'Neutral_0_White', // White
  Neutral_100 = 'Neutral_100', // Ghost White_20
  Neutral_200_OffWhite = 'Neutral_200_OffWhite', // Ghost White_30
  Neutral_300 = 'Neutral_300', // Ghost White_60
  Neutral_400 = 'Neutral_400', // Ghost White_80
  Neutral_500 = 'Neutral_500', // Ghost White
  Neutral_600 = 'Neutral_600', // Black_20
  Neutral_700 = 'Neutral_700', // Black_40
  Neutral_800 = 'Neutral_800', // Black_60
  Neutral_900 = 'Neutral_900', // Black_80
  Neutral_950_TechDarkGrey = 'Neutral_950_TechDarkGrey', // Black_90
  Neutral_1000_Black = 'Neutral_1000_Black', // Black

  Purple_600 = 'Purple_600', // Technology purple_20
  Purple_700 = 'Purple_700', // Technology purple_40
  Purple_800 = 'Purple_800', // Technology purple_60
  Purple_900 = 'Purple_900', // Technology purple_80
  Purple_1000_Technology = 'Purple_1000_Technology', // Technology purple

  Red_100 = 'Red_100',
  Red_200 = 'Red_200',
  Red_300 = 'Red_300',
  Red_400 = 'Red_400',
  Red_500_Danger = 'Red_500_Danger',
  Red_600 = 'Red_600',
  Red_700 = 'Red_700',
  Red_800 = 'Red_800',
  Red_900 = 'Red_900',
  Red_1000 = 'Red_1000',

  Yellow_100 = 'Yellow_100',
  Yellow_200 = 'Yellow_200',
  Yellow_300 = 'Yellow_300',
  Yellow_400 = 'Yellow_400',
  Yellow_500_Warning = 'Yellow_500_Warning',
  Yellow_600 = 'Yellow_600',
  Yellow_700 = 'Yellow_700',
  Yellow_800_Gold = 'Yellow_800_Gold',
  Yellow_900 = 'Yellow_900',
  Yellow_1000_Orange = 'Yellow_1000_Orange',
}

export enum ColorName {
  Blue_100 = 'Ultramarine blue 20',
  Blue_200 = 'Ultramarine blue 40',
  Blue_300 = 'Ultramarine blue 60',
  Blue_400 = 'Ultramarine blue 80',
  Blue_500_Ultramarine = 'Ultramarine blue',
  Blue_600 = 'Deep blue 20',
  Blue_700 = 'Deep blue 40',
  Blue_800 = 'Deep blue 60',
  Blue_900 = 'Deep blue 80',
  Blue_1000_Deep = 'Deep blue',

  Green_100 = 'Green 20',
  Green_200 = 'Green 40',
  Green_300 = 'Green 60',
  Green_400 = 'Green 80',
  Green_500_Success = 'Green',
  Green_600 = 'Sacramento state green 20',
  Green_700_Shop = 'Sacramento state green 40',
  Green_800 = 'Sacramento state green 60',
  Green_900 = 'Sacramento state green 80',
  Green_1000_Energy = 'Sacramento state green',

  Neutral_0_White = 'White',
  Neutral_100 = 'Ghost white 20',
  Neutral_200_OffWhite = 'Ghost white 30',
  Neutral_300 = 'Ghost white 60',
  Neutral_400 = 'Ghost white 80',
  Neutral_500 = 'Ghost white',
  Neutral_600 = 'Black 20',
  Neutral_700 = 'Black 40',
  Neutral_800 = 'Black 60',
  Neutral_900 = 'Black 80',
  Neutral_950_TechDarkGrey = 'Tech dark grey',
  Neutral_1000_Black = 'Black',

  Purple_600 = 'Technology purple 20',
  Purple_700 = 'Technology purple 40',
  Purple_800 = 'Technology purple 60',
  Purple_900 = 'Technology purple 80',
  Purple_1000_Technology = 'Technology purple',

  Red_100 = 'Red 20',
  Red_200 = 'Red 40',
  Red_300 = 'Red 60',
  Red_400 = 'Red 80',
  Red_500_Danger = 'Red',
  Red_600 = 'Dark red 20',
  Red_700 = 'Dark red 40',
  Red_800 = 'Dark red 60',
  Red_900 = 'Dark red 80',
  Red_1000 = 'Dark red',

  Yellow_100 = 'Yellow 20',
  Yellow_200 = 'Yellow 40',
  Yellow_300 = 'Yellow 60',
  Yellow_400 = 'Yellow 80',
  Yellow_500_Warning = 'Yellow',
  Yellow_600 = 'Orange 20',
  Yellow_700 = 'Orange 40',
  Yellow_800_Gold = 'Orange 60',
  Yellow_900 = 'Orange 80',
  Yellow_1000_Orange = 'Orange',
}

export const colorToColorName: { [key in Color]: ColorName } = {
  [Color.Blue_100]: ColorName.Blue_100,
  [Color.Blue_200]: ColorName.Blue_200,
  [Color.Blue_300]: ColorName.Blue_300,
  [Color.Blue_400]: ColorName.Blue_400,
  [Color.Blue_500_Ultramarine]: ColorName.Blue_500_Ultramarine,
  [Color.Blue_600]: ColorName.Blue_600,
  [Color.Blue_700]: ColorName.Blue_700,
  [Color.Blue_800]: ColorName.Blue_800,
  [Color.Blue_900]: ColorName.Blue_900,
  [Color.Blue_1000_Deep]: ColorName.Blue_1000_Deep,

  [Color.Green_100]: ColorName.Green_100,
  [Color.Green_200]: ColorName.Green_200,
  [Color.Green_300]: ColorName.Green_300,
  [Color.Green_400]: ColorName.Green_400,
  [Color.Green_500_Success]: ColorName.Green_500_Success,
  [Color.Green_600]: ColorName.Green_600,
  [Color.Green_700_Shop]: ColorName.Green_700_Shop,
  [Color.Green_800]: ColorName.Green_800,
  [Color.Green_900]: ColorName.Green_900,
  [Color.Green_1000_Energy]: ColorName.Green_1000_Energy,

  [Color.Neutral_0_White]: ColorName.Neutral_0_White,
  [Color.Neutral_100]: ColorName.Neutral_100,
  [Color.Neutral_200_OffWhite]: ColorName.Neutral_200_OffWhite,
  [Color.Neutral_300]: ColorName.Neutral_300,
  [Color.Neutral_400]: ColorName.Neutral_400,
  [Color.Neutral_500]: ColorName.Neutral_500,
  [Color.Neutral_600]: ColorName.Neutral_600,
  [Color.Neutral_700]: ColorName.Neutral_700,
  [Color.Neutral_800]: ColorName.Neutral_800,
  [Color.Neutral_900]: ColorName.Neutral_900,
  [Color.Neutral_950_TechDarkGrey]: ColorName.Neutral_950_TechDarkGrey,
  [Color.Neutral_1000_Black]: ColorName.Neutral_1000_Black,

  [Color.Purple_600]: ColorName.Purple_600,
  [Color.Purple_700]: ColorName.Purple_700,
  [Color.Purple_800]: ColorName.Purple_800,
  [Color.Purple_900]: ColorName.Purple_900,
  [Color.Purple_1000_Technology]: ColorName.Purple_1000_Technology,

  [Color.Red_100]: ColorName.Red_100,
  [Color.Red_200]: ColorName.Red_200,
  [Color.Red_300]: ColorName.Red_300,
  [Color.Red_400]: ColorName.Red_400,
  [Color.Red_500_Danger]: ColorName.Red_500_Danger,
  [Color.Red_600]: ColorName.Red_600,
  [Color.Red_700]: ColorName.Red_700,
  [Color.Red_800]: ColorName.Red_800,
  [Color.Red_900]: ColorName.Red_900,
  [Color.Red_1000]: ColorName.Red_1000,

  [Color.Yellow_100]: ColorName.Yellow_100,
  [Color.Yellow_200]: ColorName.Yellow_200,
  [Color.Yellow_300]: ColorName.Yellow_300,
  [Color.Yellow_400]: ColorName.Yellow_400,
  [Color.Yellow_500_Warning]: ColorName.Yellow_500_Warning,
  [Color.Yellow_600]: ColorName.Yellow_600,
  [Color.Yellow_700]: ColorName.Yellow_700,
  [Color.Yellow_800_Gold]: ColorName.Yellow_800_Gold,
  [Color.Yellow_900]: ColorName.Yellow_900,
  [Color.Yellow_1000_Orange]: ColorName.Yellow_1000_Orange,
};

export const colorNameToColor: { [key in ColorName]: Color } = {
  [ColorName.Blue_100]: Color.Blue_100,
  [ColorName.Blue_200]: Color.Blue_200,
  [ColorName.Blue_300]: Color.Blue_300,
  [ColorName.Blue_400]: Color.Blue_400,
  [ColorName.Blue_500_Ultramarine]: Color.Blue_500_Ultramarine,
  [ColorName.Blue_600]: Color.Blue_600,
  [ColorName.Blue_700]: Color.Blue_700,
  [ColorName.Blue_800]: Color.Blue_800,
  [ColorName.Blue_900]: Color.Blue_900,
  [ColorName.Blue_1000_Deep]: Color.Blue_1000_Deep,

  [ColorName.Green_100]: Color.Green_100,
  [ColorName.Green_200]: Color.Green_200,
  [ColorName.Green_300]: Color.Green_300,
  [ColorName.Green_400]: Color.Green_400,
  [ColorName.Green_500_Success]: Color.Green_500_Success,
  [ColorName.Green_600]: Color.Green_600,
  [ColorName.Green_700_Shop]: Color.Green_700_Shop,
  [ColorName.Green_800]: Color.Green_800,
  [ColorName.Green_900]: Color.Green_900,
  [ColorName.Green_1000_Energy]: Color.Green_1000_Energy,

  [ColorName.Neutral_0_White]: Color.Neutral_0_White,
  [ColorName.Neutral_100]: Color.Neutral_100,
  [ColorName.Neutral_200_OffWhite]: Color.Neutral_200_OffWhite,
  [ColorName.Neutral_300]: Color.Neutral_300,
  [ColorName.Neutral_400]: Color.Neutral_400,
  [ColorName.Neutral_500]: Color.Neutral_500,
  [ColorName.Neutral_600]: Color.Neutral_600,
  [ColorName.Neutral_700]: Color.Neutral_700,
  [ColorName.Neutral_800]: Color.Neutral_800,
  [ColorName.Neutral_900]: Color.Neutral_900,
  [ColorName.Neutral_950_TechDarkGrey]: Color.Neutral_950_TechDarkGrey,
  [ColorName.Neutral_1000_Black]: Color.Neutral_1000_Black,

  [ColorName.Purple_600]: Color.Purple_600,
  [ColorName.Purple_700]: Color.Purple_700,
  [ColorName.Purple_800]: Color.Purple_800,
  [ColorName.Purple_900]: Color.Purple_900,
  [ColorName.Purple_1000_Technology]: Color.Purple_1000_Technology,

  [ColorName.Red_100]: Color.Red_100,
  [ColorName.Red_200]: Color.Red_200,
  [ColorName.Red_300]: Color.Red_300,
  [ColorName.Red_400]: Color.Red_400,
  [ColorName.Red_500_Danger]: Color.Red_500_Danger,
  [ColorName.Red_600]: Color.Red_600,
  [ColorName.Red_700]: Color.Red_700,
  [ColorName.Red_800]: Color.Red_800,
  [ColorName.Red_900]: Color.Red_900,
  [ColorName.Red_1000]: Color.Red_1000,

  [ColorName.Yellow_100]: Color.Yellow_100,
  [ColorName.Yellow_200]: Color.Yellow_200,
  [ColorName.Yellow_300]: Color.Yellow_300,
  [ColorName.Yellow_400]: Color.Yellow_400,
  [ColorName.Yellow_500_Warning]: Color.Yellow_500_Warning,
  [ColorName.Yellow_600]: Color.Yellow_600,
  [ColorName.Yellow_700]: Color.Yellow_700,
  [ColorName.Yellow_800_Gold]: Color.Yellow_800_Gold,
  [ColorName.Yellow_900]: Color.Yellow_900,
  [ColorName.Yellow_1000_Orange]: Color.Yellow_1000_Orange,
};

const BackgroundColorDefaultWithoutDeepBlue = {
  Green_1000_Energy: ColorName.Green_1000_Energy,
  Neutral_0_White: ColorName.Neutral_0_White,
  Neutral_200_OffWhite: ColorName.Neutral_200_OffWhite,
  Neutral_950_TechDarkGrey: ColorName.Neutral_950_TechDarkGrey,
};

const BackgroundColorDefaultWithDeepBlue = {
  ...BackgroundColorDefaultWithoutDeepBlue,
  Blue_1000_Deep: ColorName.Blue_1000_Deep, // this is called "Dark" in Electricity Tariff
};

const BackgroundColorContentCard = {
  Blue_1000_Deep: ColorName.Blue_1000_Deep, // this is called "Dark" in Electricity Tariff
  Green_1000_Energy: ColorName.Green_1000_Energy,
  Neutral_0_White: ColorName.Neutral_0_White,
  Neutral_950_TechDarkGrey: ColorName.Neutral_950_TechDarkGrey,
};

const BackgroundColorHeroElement = {
  Blue_1000_Deep: ColorName.Blue_1000_Deep, // this is called "Dark" in Electricity Tariff
  Green_1000_Energy: ColorName.Green_1000_Energy,
  Neutral_0_White: ColorName.Neutral_0_White,
  Neutral_200_OffWhite: ColorName.Neutral_200_OffWhite,
  Neutral_950_TechDarkGrey: ColorName.Neutral_950_TechDarkGrey,
  Purple_1000_Technology: ColorName.Purple_1000_Technology,
};

const BackgroundColorVideo = BackgroundColorHeroElement;

const BackgroundColorImage = BackgroundColorHeroElement;

const BackgroundColorStatsEntry = {
  Blue_1000_Deep: ColorName.Blue_1000_Deep, // this is called "Dark" in Electricity Tariff
  Blue_500_Ultramarine: ColorName.Blue_500_Ultramarine,
  Blue_Deep_600: ColorName.Blue_600,
  Blue_Deep_700: ColorName.Blue_700,
  Blue_Deep_800: ColorName.Blue_800,
  Blue_Deep_900: ColorName.Blue_900,
  Green_1000_Energy: ColorName.Green_1000_Energy,
  Neutral_950_TechDarkGrey: ColorName.Neutral_950_TechDarkGrey,
};

const TextColor = {
  Blue_1000_Deep: ColorName.Blue_1000_Deep, // this is called "Dark" in Electricity Tariff
  Neutral_0_White: ColorName.Neutral_0_White,
};

const HoverColor = {
  Blue_1000_Deep: ColorName.Blue_1000_Deep, // this is called "Dark" in Electricity Tariff
  Neutral_0_White: ColorName.Neutral_0_White,
};

const ForegroundTextColor = {
  Blue_1000_Deep: ColorName.Blue_1000_Deep, // this is called "Dark" in Electricity Tariff
  Blue_500_Ultramarine: ColorName.Blue_500_Ultramarine,
  Neutral_0_White: ColorName.Neutral_0_White,
  Purple_1000_Technology: ColorName.Purple_1000_Technology,
};

const BackgroundTextColor = {
  Blue_1000_Deep: ColorName.Blue_1000_Deep, // this is called "Dark" in Electricity Tariff
  Blue_500_Ultramarine: ColorName.Blue_500_Ultramarine,
  Neutral_0_White: ColorName.Neutral_0_White,
};

const TextColorHero = {
  Blue_1000_Deep: ColorName.Blue_1000_Deep, // this is called "Dark" in Electricity Tariff
  Green_1000_Energy: ColorName.Green_1000_Energy,
  Neutral_0_White: ColorName.Neutral_0_White,
};

const InteractiveCardsColor = {
  Blue_1000_Deep: ColorName.Blue_1000_Deep, // this is called "Dark" in Electricity Tariff
  Blue_Deep_900: ColorName.Blue_900,
  Green_1000_Energy: ColorName.Green_1000_Energy,
  Neutral_0_White: ColorName.Neutral_0_White,
  Neutral_200_OffWhite: ColorName.Neutral_200_OffWhite,
};

const HeaderThemeColor = {
  Blue_1000_Deep: ColorName.Blue_1000_Deep, // this is called "Dark" in Electricity Tariff
  Neutral_0_White: ColorName.Neutral_0_White,
  Neutral_1000_Black: ColorName.Neutral_1000_Black,
  Neutral_200_OffWhite: ColorName.Neutral_200_OffWhite,
  Purple_1000_Technology: ColorName.Purple_1000_Technology,
};

const HeaderThemeBelowFoldColor = {
  Blue_1000_Deep: ColorName.Blue_1000_Deep, // this is called "Dark" in Electricity Tariff
  Neutral_0_White: ColorName.Neutral_0_White,
  Purple_1000_Technology: ColorName.Purple_1000_Technology,
};

const PageNavigationThemeColor = {
  ...HeaderThemeColor,
  Blue_900: ColorName.Blue_900,
  Neutral_300: ColorName.Neutral_300,
  Green_1000_Energy: ColorName.Green_1000_Energy,
};

export const customColorToCategory = {
  BackgroundColorContentCard,
  BackgroundColorDefaultWithDeepBlue,
  BackgroundColorDefaultWithoutDeepBlue,
  BackgroundColorHeroElement,
  BackgroundColorImage,
  BackgroundColorStatsEntry,
  BackgroundColorVideo,
  BackgroundTextColor,
  ForegroundTextColor,
  HeaderThemeBelowFoldColor,
  HeaderThemeColor,
  HoverColor,
  InteractiveCardsColor,
  PageNavigationThemeColor,
  TextColor,
  TextColorHero,
};

export default { customColorToCategory, ColorName };
